import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';

export const useAddContacts = ({
	onError,
	onSuccess,
	userSession,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	userSession: Api.UserSessionContext;
}) => {
	return useMutation({
		mutationFn: ({ names }: { names: string[] }) => {
			return new Promise((resolve, reject) => {
				userSession.webServiceHelper
					.callWebServiceRawResponse('admin/knownNames/load', 'POST', names, resolve, reject)
					.catch(reject);
			});
		},
		onError,
		onSuccess,
	});
};
